import type {
  ComponentGraphData,
  GraphModelShape,
  ReferenceGraphData,
} from './types';

export const TAGS_FIELD_NAME = '_tags';

/** Fresh instance per call — safe to use as a mutable initial value. */
export const getEmptyReferenceGraphData = (): ReferenceGraphData => ({
  sourceMap: new Map(),
  targetMap: new Map(),
  referenceMap: new Map(),
  referenceTypes: [],
});

/**
 * Fresh instance per call. Reference-only producers spread this into
 * their return value to satisfy the GraphModelShape type without
 * sharing maps between consumers.
 */
export const getEmptyComponentGraphData = (): ComponentGraphData => ({
  childrenByParent: new Map(),
  componentsById: {},
});

/** Fresh instance per call — safe to use as a mutable initial value. */
export const getEmptyGraphModel = (): GraphModelShape => ({
  ...getEmptyReferenceGraphData(),
  ...getEmptyComponentGraphData(),
});

export enum ReferenceLabelSource {
  NONE = 'none',
  DISPLAY_TEXT = 'displayText',
  REFERENCE_TYPE = 'refType',
  DISPLAY_TEXT_OR_REFERENCE_TYPE = 'displayTextOrRefType',
}

export enum ComponentLabelSource {
  NONE = 'none',
  NAME = 'name',
  TYPE = 'type',
}

export const COMPONENT_OR_REFERENCE_DESCRIPTION_FIELD_LABEL =
  'componentOrReferenceDescription';
